import { CheckResult } from "../types";

export const COMPLIANCE_REVIEW_HOLD_STATUSES = [
  "PENDING_COMPLIANCE_REVIEW",
  "IN_COMPLIANCE_REVIEW",
];

export function isComplianceReviewHoldStatus(status: string): boolean {
  return COMPLIANCE_REVIEW_HOLD_STATUSES.includes(status);
}

function walkChecks(
  checks: CheckResult[],
  predicate: (check: CheckResult) => boolean
): boolean {
  return checks.some(
    (check) =>
      predicate(check) ||
      (check.child_checks ? walkChecks(check.child_checks, predicate) : false)
  );
}

export function caseHasComplianceReviewHold(checks: CheckResult[]): boolean {
  return walkChecks(checks, (check) =>
    isComplianceReviewHoldStatus(check.status)
  );
}
